module.exports = __webpack_public_path__ + "assets/img/teacher (51).d11cf6fb.png";